const useString = () => {

    const strContem = (conteudo, contem) => {
        conteudo = removeAcentos(conteudo);
        contem = removeAcentos(contem);
        return conteudo.indexOf(contem) >= 0;
    }

    const removeAcentos = (descricao) => {
        descricao = descricao.toUpperCase();
        descricao = descricao.replace(/Á|À|Ä|Ã|Â/g, "A");
        descricao = descricao.replace(/È|É|Ë|Ê|Ẽ/g, "E");
        descricao = descricao.replace(/Ì|Í|Ï|Î|Ĩ/g, "I");
        descricao = descricao.replace(/Ó|Ò|Ö|Õ/g, "O");
        descricao = descricao.replace(/Ù|Ú|Ü|Û|Ũ/g, "U");
        descricao = descricao.replace(/Ç|Ć|Ĉ|Ḉ/g, "C");
        descricao = descricao.replace(/Ẃ|Ẁ|Ŵ|Ẅ/g, "W");
        descricao = descricao.replace(/Ŕ/g, "R");
        descricao = descricao.replace(/Ỳ|Ý|Ŷ|Ỹ|Ÿ/g, "Y");
        descricao = descricao.replace(/Ṕ/g, "P");
        descricao = descricao.replace(/Ś|Ŝ|Ŝ/g, "S");
        descricao = descricao.replace(/Ǵ|Ĝ/g, "G");
        descricao = descricao.replace(/J́|Ĵ/g, "J");
        descricao = descricao.replace(/Ḱ/g, "K");
        descricao = descricao.replace(/Ĺ/g, "L");
        descricao = descricao.replace(/Ź|Ẑ/g, "Z");
        descricao = descricao.replace(/Ǹ|Ń|Ñ/g, "N");
        descricao = descricao.replace(/M̀|Ḿ/g, "M");

        return descricao;
    }

    return {strContem};

}


export {useString};